'use client';
import React, { createContext } from 'react';

/**
 * Which block the hooks below are being called under. Set once per block by
 * the host's block mapper, never re-provided for data: the store changes on
 * every recalculation, the address never does, so the two stay apart.
 */
export const CalculationScopeContext = createContext<string | undefined>(
  undefined,
);

export const CalculationScope: React.FC<{
  moduleId: string;
  children: React.ReactNode;
}> = ({ moduleId, children }) => (
  <CalculationScopeContext.Provider value={moduleId}>
    {children}
  </CalculationScopeContext.Provider>
);
